import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import MobileLayout from "../../components/MobileLayout";
import { Md3Button } from "../../shared/components";
import { useGameWords } from "../../hooks/useGameWords";
import CompleteSignGame from "./CompleteSign";
import WordCompletionGame from "./WordCompletion";
import FlashcardsGame from "./Flashcards";
import WordMatchingGame from "./WordMatching";
import DactylologyPuzzleGame from "./DactylologyPuzzle";
import WordBuilderGame from "./WordBuilder";
import ConnectDotsGame from "./ConnectDots";
import SignPuzzleGame from "./SignPuzzle";
import { GamePageRoot } from "./gameStyles";

const GamePlayPage: React.FC = () => {
  const { gameId } = useParams<{ gameId: string }>();
  const navigate = useNavigate();
  const { words, loading, pickWords } = useGameWords(16);

  if (loading) {
    return (
      <MobileLayout
        headerTitle="Carregando jogo…"
        headerType="private"
        showBannerAd={false}
      >
        <GamePageRoot>
          <p>Preparando palavras do sinalário…</p>
        </GamePageRoot>
      </MobileLayout>
    );
  }

  if (!words.length) {
    return (
      <MobileLayout
        headerTitle="Jogos"
        headerType="private"
        showBannerAd={false}
      >
        <GamePageRoot>
          <p>Não encontramos palavras com mídia para jogar agora.</p>
          <Md3Button title="Voltar" onClick={() => navigate("/games")} />
        </GamePageRoot>
      </MobileLayout>
    );
  }

  const round = pickWords(12);
  const exit = () => navigate("/games");

  switch (gameId) {
    case "flashcards":
      return <FlashcardsGame words={round} mode="signs" onExit={exit} />;
    case "flashcardsImages":
      return <FlashcardsGame words={round} mode="images" onExit={exit} />;
    case "wordCompletion":
      return <WordCompletionGame words={round} onExit={exit} />;
    case "wordMatching":
      return <WordMatchingGame words={round} onExit={exit} />;
    case "completeSign":
      return <CompleteSignGame words={round} onExit={exit} />;
    case "wordBuilder":
      return <WordBuilderGame words={round} onExit={exit} />;
    case "connectDots":
      return <ConnectDotsGame words={round} onExit={exit} />;
    case "signPuzzle":
      return <SignPuzzleGame words={round} onExit={exit} />;
    case "dactylologyPuzzle":
      return <DactylologyPuzzleGame words={round} onExit={exit} />;
    case "signBuilder":
      return <CompleteSignGame words={round} onExit={exit} />;
    default:
      return (
        <MobileLayout
          headerTitle="Jogo"
          headerType="private"
          showBannerAd={false}
        >
          <GamePageRoot>
            <p>Jogo não encontrado.</p>
            <Md3Button
              title="Voltar aos jogos"
              onClick={() => navigate("/games")}
            />
          </GamePageRoot>
        </MobileLayout>
      );
  }
};

export default GamePlayPage;
